"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SzSideMenu = void 0;

var react_1 = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var react_transition_group_1 = require("react-transition-group");

var react_spring_1 = require("react-spring");

require("./SzSideMenu.scss");

var SzTypographie_1 = __importDefault(require("../SzTypographie/SzTypographie"));

exports.SzSideMenu = function (props) {
  var children = props.children,
      className = props.className,
      isOpen = props.isOpen,
      footer = props.footer;
  var menuClasses = classnames_1.default('sz-aside overflow-hidden bg-white text-secondary d-flex flex-column position-relative', className, {
    open: isOpen
  });
  return react_1.default.createElement(react_transition_group_1.CSSTransition, {
    in: isOpen,
    timeout: 0,
    classNames: "sz-aside"
  }, react_1.default.createElement("aside", {
    className: menuClasses
  }, react_1.default.createElement("nav", {
    className: "h-100"
  }, react_1.default.createElement("ul", {
    className: "sz-aside__list list-unstyled m-0 d-flex flex-column flex-nowrap h-100"
  }, children)), footer && react_1.default.createElement(Footer, {
    title: footer,
    isOpen: isOpen
  })));
};

var Footer = function Footer(_a) {
  var title = _a.title,
      isOpen = _a.isOpen;

  var _b = __read(react_1.useState(false), 2),
      loaded = _b[0],
      setLoaded = _b[1];

  var minWidth = isOpen ? 200 : 60;

  var _c = __read(react_spring_1.useSpring(function () {
    return {
      from: {
        opacity: 0,
        width: '100%',
        'text-align': 'center',
        'min-width': 200
      },
      to: {
        opacity: 1,
        width: '100%',
        'text-align': 'center',
        'min-width': 60
      }
    };
  }), 2),
      styles = _c[0],
      animate = _c[1];

  react_1.useEffect(function () {
    if (loaded) {
      animate({
        from: {
          opacity: 0,
          width: '100%',
          'text-align': 'center',
          'min-width': minWidth
        },
        to: {
          opacity: 1,
          width: '100%',
          'text-align': 'center',
          'min-width': minWidth
        }
      });
    } else {
      setLoaded(true);
    }
  }, [animate, isOpen, loaded, minWidth]);
  return react_1.default.createElement("div", {
    className: "sz-aside__footer sz-top-border mt-auto bg-primary-dark"
  }, react_1.default.createElement(react_spring_1.animated.div, {
    style: styles
  }, react_1.default.createElement(SzTypographie_1.default, {
    tag: "span",
    weight: "medium",
    color: "light"
  }, title)));
};

var Item = function Item(_a) {
  var _b;

  var children = _a.children,
      active = _a.active,
      onClick = _a.onClick,
      className = _a.className,
      order = _a.order,
      color = _a.color;
  var itemClasses = classnames_1.default('sz-aside__item d-flex align-items-center cursor-pointer', className, (_b = {}, _b["order-" + order] = order && order >= 0, _b.active = active, _b));
  var beforeClasses = classnames_1.default('sz-aside__item--before', {
    'bg-primary-dark': color === 'dark',
    'bg-primary-brand': color === 'brand'
  });
  return react_1.default.createElement("li", {
    className: itemClasses,
    onClick: onClick
  }, react_1.default.createElement("span", {
    className: beforeClasses
  }), children);
};

exports.SzSideMenu.Item = Item;
exports.default = exports.SzSideMenu;